// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"534":"692c4b58","575":"dda62416","633":"26d4d349","748":"9e5fef09","943":"93aa4ea5"}[chunkId] + ".chunk.js";
};